import React from 'react';
import clsx from 'clsx';
import {
  Element,
  Typography,
  Color,
  FontType,
  Align,
  MatchHeight
} from '@americanexpress/aqx-components';
import CtaRow from './CtaRow';
import styles from './__styles__/tabControl.scss?modules';
import isProduction from 'src/universal/utils/isProduction';
import { connect } from 'react-redux';
import { getPageCardsData } from 'src/universal/redux/page';

const findLinkByKey = (links, key) => {
  return (links || []).find(l => l.key === key);
};

const findLinkByParticalKey = (links, key) => {
  return (links || []).find(l => String(l.key).endsWith(key));
};

/* eslint-disable complexity */
const TabContent = ({ content, index, cardData, activeIndex }) => {
  const {
    cardArtUrl,
    cardArtAlt,
    description,
    headline,
    links,
    shortName
  } = content;
  const hasImg = !!cardArtUrl;
  const ctaLink = findLinkByParticalKey(links, 'Cta');
  const offerTermsLink = findLinkByKey(links, 'offerTerms');
  const rateAndFeesLink = findLinkByKey(links, 'rateAndFees');
  const cardArtLink = findLinkByParticalKey(links, 'CardArt');
  const renderImg = hasImg && index === activeIndex;
  const ctaRowProps = {
    ctaLink,
    offerTermsLink,
    rateAndFeesLink,
    shortName,
    cardData
  };
  return (
    <Element
      className={clsx(styles.tabContent, {
        [styles.hasNoImg]: !hasImg
      })}
    >
      <Element className={styles.left}>
        <MatchHeight name="upperContent">
          <div>
            <div className={styles.sideBySide}>
              <Element className={styles.contentHeader} Component="span">
                <Typography
                  Component="h2"
                  $lineHeight="130%"
                  theme={{
                    color: Color.DeepBlue,
                    fontType: FontType.BentonBold,
                    textAlign: Align.Left,
                    marginBottom: 5
                  }}
                  className={styles.titleText}
                >
                  {headline}
                </Typography>
              </Element>
              {renderImg && (
                <div className={styles.imgWrap}>
                  <img
                    className={styles.mobileImage}
                    src={cardArtUrl}
                    alt={cardArtAlt}
                    onClick={() => {
                      if (cardArtLink) {
                        if (!isProduction()) {
                          console.log(`url: ${cardArtLink.url}`);
                        }
                        window.location.href = cardArtLink.url;
                      }
                    }}
                  />
                </div>
              )}
            </div>
            <Element className={styles.contentTxt} Component="div">
              <Typography
                Component="div"
                $lineHeight={'130%'}
                theme={{
                  color: Color.Gray06,
                  fontType: FontType.HelveticaRegular,
                  textAlign: Align.Left,
                  marginBottom: 5
                }}
              >
                {description}
              </Typography>
            </Element>
          </div>
        </MatchHeight>
        <CtaRow {...ctaRowProps} />
      </Element>
      {renderImg && (
        <img
          className={styles.desktopImage}
          src={cardArtUrl}
          alt={cardArtAlt}
          onClick={() => {
            if (cardArtLink) {
              if (!isProduction()) {
                console.log(`url: ${cardArtLink.url}`);
              }
              window.location.href = cardArtLink.url;
            }
          }}
        />
      )}
    </Element>
  );
};

const mapStateToProps = state => {
  return {
    cardData: getPageCardsData(state)
  };
};

export default connect(mapStateToProps)(React.memo(TabContent));
